import { CsvHeaderModel } from '../../../models/CsvHeader';

export const RIDER_REPORT_HEADER: CsvHeaderModel[] = [
  {
    label: 'ຊື່ຂອງຄົນຂັບ',
    key: 'username',
  },
  {
    label: 'ຕຳແໜ່ງ',
    key: 'type',
  },
  {
    label: 'ຈຳນວນຮອບທັງໝົດ',
    key: 'totalRound',
  },
  {
    label: 'ຈຳນວນອໍເດີ',
    key: 'orderAmount',
  },
  {
    label: 'ໄລຍະທາງທີ່ແລ່ນໄດ້ທັງໝົດ',
    key: 'totalDistanceRiderGot',
  },
  {
    label: 'ຈຳນວນເງິນຄົນຂັບໄດ້',
    key: 'totalMoney',
  },
  {
    label: 'ຈຳນວນເງິນທັງໝົດ',
    key: 'total',
  },
];
